import dayjs from "dayjs";
import "dayjs/locale/th";
import { formatDateTimeBkk } from "../../utils/date";
import { DISPLAY_DATE_FORMAT, EMPTY_CELL_TEXT } from "./constants";

/** Read in Thai explicitly, so the output never depends on the locale another module set last. */
const THAI_LOCALE = "th";

/** A business day (`YYYY-MM-DD`, no zone) as the report pages write it: 20/10/2026. */
export const formatBusinessDate = (businessDate: string) =>
  dayjs(businessDate).format(DISPLAY_DATE_FORMAT);

/** อ. — beside the date in a list row. */
export const weekdayShortOf = (businessDate: string) =>
  dayjs(businessDate).locale(THAI_LOCALE).format("dd");

/** วันอังคาร 20/10/2026 — the heading of one day. */
export const formatDayTitle = (businessDate: string) =>
  `วัน${dayjs(businessDate).locale(THAI_LOCALE).format("dddd")} ${formatBusinessDate(businessDate)}`;

/** A submit / review instant on the Bangkok clock, or – when there is none. */
export const formatTimestamp = (timestamp: string | null) =>
  formatDateTimeBkk(timestamp) || EMPTY_CELL_TEXT;

/** ตุลาคม 2026 — the month a list covers. */
export const formatMonthLabel = (month: string) =>
  dayjs(`${month}-01`).locale(THAI_LOCALE).format("MMMM YYYY");
